<!-- HRN-1592: Complex button - manual conversion needed -->
@if (standardViews().length > 0 || userViews().length > 0) {
  <div ngbDropdown class="d-inline-block" container="body" placement="bottom-right" autoClose="false" #viewsDropdown="ngbDropdown">
    <button type="button" class="btn btn-link" ngbDropdownToggle>
      {{ getButtonText() }}
    </button>

    <div ngbDropdownMenu class="viewsDropdownMenu p-0">
      <div class="d-flex flex-column gap-2 p-3">
        <h6 class="mb-2 group-title">
          {{ 'pages.transport.tracking-list.standard-views' | translate }}
        </h6>
        <p-scrollpanel>
          <div class="d-flex flex-column gap-2">
            @if (standardViews().length === 0) {
              <div class="text-muted fst-italic px-2 py-1">No views found</div>
            } @else {
              @for (view of standardViews(); track view.id) {
                <div class="d-flex align-items-center gap-2">
                  <button
                    ngbDropdownItem
                    class="flex-grow-1 text-start rounded d-flex align-items-center gap-2"
                    #deleteStandardViewPopoverTarget
                    [class.active]="selectedView() === view.id"
                    (click)="selectView(view.id)"
                  >
                    @if (selectedView() === view.id) {
                      <em aria-hidden="true" class="pi pi-star-fill"></em>
                    }
                    {{ view.name }}
                  </button>

                  @if (isAdmin()) {
                    <button
                      type="button"
                      class="btn btn-link btn-sm rounded"
                      [ngbPopover]="deleteConfirmationTemplate"
                      [positionTarget]="deleteStandardViewPopoverTarget"
                      container="body"
                      placement="start"
                      triggers="manual"
                      popoverClass="delete-view-popover"
                      #deletePopover="ngbPopover"
                      (hidden)="currentPopover === deletePopover ? onPopoverHidden() : null"
                      (click)="
                        viewToDelete() === view.id ? deletePopover.close() : showDeleteConfirmation(view.id, deletePopover);
                        $event.stopPropagation()
                      "
                    >
                      <em aria-hidden="true" class="pi pi-trash"></em>
                    </button>
                  }
                </div>
              }
            }
          </div>
        </p-scrollpanel>

        <hr class="my-2" />

        <h6 class="mb-2">
          {{ 'pages.transport.tracking-list.your-views' | translate }}
        </h6>
        <p-scrollpanel>
          <div class="d-flex flex-column gap-2">
            @if (userViews().length === 0) {
              <div class="text-muted fst-italic px-2 py-1">No views found</div>
            } @else {
              @for (view of userViews(); track view.id) {
                <div class="d-flex align-items-center gap-2">
                  <button
                    ngbDropdownItem
                    #deleteCustomViewPopoverTarget
                    class="flex-grow-1 text-start rounded d-flex align-items-center gap-2"
                    [class.active]="selectedView() === view.id"
                    (click)="selectView(view.id)"
                  >
                    @if (selectedView() === view.id) {
                      <em aria-hidden="true" class="pi pi-star-fill"></em>
                    }
                    {{ view.name }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-link btn-sm rounded"
                    [ngbPopover]="deleteConfirmationTemplate"
                    container="body"
                    placement="start"
                    [positionTarget]="deleteCustomViewPopoverTarget"
                    triggers="manual"
                    popoverClass="delete-view-popover"
                    #deletePopover="ngbPopover"
                    (hidden)="currentPopover === deletePopover ? onPopoverHidden() : null"
                    (click)="
                      viewToDelete() === view.id ? deletePopover.close() : showDeleteConfirmation(view.id, deletePopover);
                      $event.stopPropagation()
                    "
                  >
                    <em aria-hidden="true" class="pi pi-trash"></em>
                  </button>
                </div>
              }
            }
          </div>
        </p-scrollpanel>
      </div>
    </div>
  </div>
}

<!-- Save View Dialog -->
<p-dialog
  [visible]="saveViewDialogVisible()"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-25 save-view-dialog"
  [header]="'Save your view'"
  (visibleChange)="onDialogVisibilityChange($event)"
>
  <div class="p-3">
    <p-floatlabel class="w-full mb-3">
      <input
        pInputText
        id="viewName"
        name="viewName"
        [(ngModel)]="newViewName"
        (ngModelChange)="updateViewName($event)"
        autocomplete="off"
        maxlength="32"
      />
      <label for="viewName">Name</label>
    </p-floatlabel>

    @if (shouldShowConflictMessage()) {
      <p-message variant="simple" size="small" severity="warn" icon="pi pi-info-circle" [text]="conflictMessageText()" styleClass="pb-2" />
    }

    @if (canShowCheckbox()) {
      <div class="d-flex align-items-center gap-2">
        <input
          type="checkbox"
          id="standardViewCheckbox"
          [(ngModel)]="isStandardView"
          (ngModelChange)="updateIsStandardView($event)"
          class="form-check-input m-0"
        />
        <label for="standardViewCheckbox" class="form-check-label"> Set as standard view for all users </label>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2 p-3">
      <p-button
        (onClick)="cancelSaveView()"
        [matomoClickCategory]="matomoTrackerCategory"
        matomoClickAction="Cancel Save View"
        matomoClickName="Button Click"
        [label]="'general.cancel' | translate"
        styleClass="mr--4"
        icon="pi pi-times"
        severity="secondary"
        [attr.aria-label]="'general.cancel' | translate"
      />
      <p-button
        (onClick)="confirmSaveView()"
        [disabled]="!newViewName().trim()"
        [matomoClickCategory]="matomoTrackerCategory"
        matomoClickAction="Save View"
        matomoClickName="Button Click"
        [label]="dialogActionText()"
        styleClass="mr--4"
        icon="pi pi-check"
        severity="primary"
        aria-label="{{ dialogActionText() }}"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Delete View Confirmation Popover Template -->
<ng-template #deleteConfirmationTemplate>
  <div class="p-3" (mousedown)="$event.stopPropagation()">
    <p class="mb-3 fs-6">{{ 'pages.transport.tracking-list.delete-view.confirm-message' | translate }}</p>
    <div class="d-flex gap-2 justify-content-end">
      <p-button
        (onClick)="cancelDeleteView(); $event.stopPropagation()"
        [label]="'general.no' | translate"
        styleClass="p-button-sm"
        severity="secondary"
        aria-label="'general.no' | translate"
      ></p-button>
      <p-button
        (onClick)="confirmDeleteView(); $event.stopPropagation()"
        [label]="'general.yes' | translate"
        styleClass="p-button-sm"
        severity="primary"
        aria-label="'general.yes' | translate"
      ></p-button>
    </div>
  </div>
</ng-template>
